/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Compare_OpenInputs */

const en_us2_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare two assessments`)
};

const pt_br2_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar duas avaliações`)
};

const es_419_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar dos evaluaciones`)
};

const pt_pt2_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar duas avaliações`)
};

const fr_fr2_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer deux évaluations`)
};

const de_de2_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei Messungen vergleichen`)
};

const it_it2_body_assessment_compare_open = /** @type {(inputs: Body_Assessment_Compare_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta due valutazioni`)
};

/**
* | output |
* | --- |
* | "Compare two assessments" |
*
* @param {Body_Assessment_Compare_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_compare_open = /** @type {((inputs?: Body_Assessment_Compare_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Compare_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_compare_open(inputs)
	if (locale === "es-419") return es_419_body_assessment_compare_open(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_compare_open(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_compare_open(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_compare_open(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_compare_open(inputs)
	return en_us2_body_assessment_compare_open(inputs)
});
export { body_assessment_compare_open as "body-assessment.compare_open" }